class Counter {
    constructor() {
        this.class = {
            module: '.module-benefitsboxnumbers',
            moduleCounter: '.benefits-counter',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        if (document.querySelector(this.class.module)) {
            const options = {
                root: null, // the viewport
                threshold: 1.0, // 100% visible
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const element = entry.target;
                        this.animateNumber(element);
                        observer.unobserve(element);
                    }
                });
            }, options);

            const modcounter = document.querySelectorAll(this.class.moduleCounter);
            modcounter.forEach((counter) => {
                observer.observe(counter);
            });
        }
    }

    animateNumber(element) {
        const numfield = element;
        const counter = element.querySelector('.number');
        const start = parseFloat(numfield.dataset.startnumber);
        const end = parseFloat(numfield.dataset.endnumber);
        const increase = parseFloat(numfield.dataset.increasenumber);
        const numType = numfield.dataset.numbertype;
        const numFloatDigits = numfield.dataset.increasenumber.length - 1;
        const duration = 2000;

        let current = start;
        const increment = increase;
        const range = parseInt(Math.ceil((end - start) / increase), 0);
        const stepTime = Math.abs(Math.floor(duration / range));

        const timer = setInterval(() => {
            current += increment;
            const cu = current.toFixed(numFloatDigits);
            if (parseFloat(cu) >= end) {
                if (parseFloat(cu) !== end) {
                    current = end;
                    counter.textContent = this.formatNumber(current, numType, numFloatDigits);
                }
                clearInterval(timer);
            }
            if (parseFloat(cu) <= end) {
                counter.textContent = this.formatNumber(current, numType, numFloatDigits);
            }
        }, stepTime);
    }

    formatNumber(num, numType, digits) {
        let retNum;
        switch (numType) {
            case 'float':
                retNum = num.toFixed(digits)
                    .replace(/\./g, ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                break;

            case 'int':
                retNum = num.toFixed(0)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                break;

            default:
                retNum = num.toFixed(0);
        }
        return retNum;
    }
}

export default new Counter();
